import { GetAnalogInventoryProcessListResponse, PostAnalogRequest, PostAnalogResponse } from "./state";

const urlAnalog = process.env.REACT_APP_ANALOG_API_URL;

export const postAnalog = async (token: string, data: PostAnalogRequest): Promise<PostAnalogResponse> => {
    const formData = new FormData();
    for (const key in data) {
        const value = data[key];
        // Agrega cada par clave-valor al formulario
        if (key === 'file_csv') {
            formData.append('file_csv', new Blob([value]));
        } else {
            formData.append(key, value);
        }
    }
    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = `${urlAnalog}/processes`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const getAnalogProcesses = async (token: string, page: number = 1): Promise<GetAnalogInventoryProcessListResponse> => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = `${urlAnalog}/processes?page=${page}`;
    const res = await fetch(urlRequest, requestOptions);
    const { data } = await res.json();
    return data;
};

export const getAnalogGalleries = async (token: string) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = `${urlAnalog}/galleries`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const postAnalogGalleries = async (token: string, image: File, name: string) => {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('name_image', name);
    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = `${urlAnalog}/galleries`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};


export const getAnalogReport = async (token: string, id: string) => {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = `${urlAnalog}/reports?process_id=${id}`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};

export const deleteAnalogReport = async (token: string, id: string) => {
    const process_id = JSON.stringify({
        "process_id": id
    });
    const requestOptions = {
        method: 'DELETE',
        body: process_id,
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };
    const urlRequest = `${urlAnalog}/processes`;
    const res = await fetch(urlRequest, requestOptions);
    return res.json();
};